import { render, staticRenderFns } from "./EmojiList.vue?vue&type=template&id=52365ea0&"
import script from "./EmojiList.vue?vue&type=script&lang=js&"
export * from "./EmojiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports